import { render } from "./PostFacesSidebarHeader.vue?vue&type=template&id=3c73d186&scoped=true&ts=true"
import script from "./PostFacesSidebarHeader.vue?vue&type=script&lang=ts"
export * from "./PostFacesSidebarHeader.vue?vue&type=script&lang=ts"

import "./PostFacesSidebarHeader.vue?vue&type=style&index=0&id=3c73d186&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c73d186"]])

export default __exports__
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpace,QBtn});
